import { API_URL } from "../config/connect";

// Без токена: админка не должна помечать уведомления прочитанными и видит все.
const getNotifications = async ({ notification_type, page = 1, limit = 10 }) => {
    // lang=ru: title/text — основной (RU) текст; переводы приходят в `translations`
    const endpoint = `${API_URL}/api/v1/notifications/${notification_type}?page=${page}&limit=${limit}&lang=ru`;
    const response = await fetch(endpoint, { method: "GET" });
    if (!response.ok) {
        throw new Error(`Ошибка при получении уведомлений (${response.status})`);
    }
    return response.json(); // { items, total, page, size, pages }
};

/** { service_count, support_count, promotions_count, ... } */
export const getNotificationCounts = async () => {
    const response = await fetch(`${API_URL}/api/v1/notifications`, { method: "GET" });
    if (!response.ok) {
        throw new Error(`Ошибка при получении счётчиков (${response.status})`);
    }
    return response.json();
};

export default getNotifications;
